const MODULE_NAME = 'IsoModule';

export const GET_ISO_NAMES = `${MODULE_NAME}/GET_ISO_NAMES`;
export const GET_ISO_GRADES = `${MODULE_NAME}/GET_ISO_GRADES`;
export const GET_ISO_VALUES = `${MODULE_NAME}/GET_ISO_VALUES`;
